import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';



const SizeDialog = () => {
  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }
  const [windowSize, setWindowSize] = useState(getWindowSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  return (
    <Dialog disableEscapeKeyDown open={windowSize.innerWidth < 600}>
      <DialogTitle
        style={{
          fontFamily: '"Montserrat", sans-serif',
          fontSize: '1.2rem',
          fontWeight: '700',
        }}>
        Alert!!!
      </DialogTitle>
      <DialogContent>
        <Box
          component="form"
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            paddingLeft: '10px',
            paddingRight: '10px',
            paddingTop: '10px',
            paddingBottom: '10px',
            fontFamily: '"Montserrat", sans-serif',
            fontSize: '0.9rem',
            // width: "400px",
            '& .MuiTextField-root': { m: 1, width: '25ch' },
          }}>
          <Typography>
            This applications is desktop view only. In order to use futher
            please resize or use desktop
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{
            fontFamily: '"Montserrat", sans-serif',
            fontSize: "0.8rem",
            backgroundColor: "#16306D",
            '&:hover': {
              backgroundColor: "#0f2454",
            }
          }}
          onClick={() => {
            window.location.assign('https://lift.lt.partners');
          }}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SizeDialog;
